export default __webpack_public_path__ + "static/media/8.eb371ad0.png";